'use client';

import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Heading } from '@/components/ui/shared/heading';

import { useUserState } from '@/components/context/UserContext';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function GeneralPractitioner() {
  const userState = useUserState();
  const history = useHistory();

  const [generalPractitionerUrl, setGeneralPractitionerUrl] = useState(null);

  const hasPractitionerFullName =
    !!userState.subscriptionInfo?.subscriptionPractitionerName &&
    !!userState.subscriptionInfo?.subscriptionPractitionerSurname;

  const hasPractitionerUrlData =
    !!userState.subscriptionInfo?.subscriptionPractitionerLocalId &&
    !!userState.subscriptionInfo?.subscriptionPractitionerServiceTypeId;

  useEffect(() => {
    if (hasPractitionerUrlData) {
      setGeneralPractitionerUrl(
        `/services/1/${userState.subscriptionInfo.subscriptionPractitionerServiceTypeId}?specialistId=${userState.subscriptionInfo.subscriptionPractitionerLocalId}`,
      );
    }
  }, [userState]);

  if (!hasPractitionerFullName && !hasPractitionerUrlData) return null;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div className="flex flex-col gap-y-2">
        <Heading variant="userAccountTitle">Šeimos gydytojas</Heading>
        {hasPractitionerFullName && (
          <Label variant="subheading">
            {`${userState.subscriptionInfo.subscriptionPractitionerName} ${userState.subscriptionInfo.subscriptionPractitionerSurname}`}
          </Label>
        )}
      </div>

      {!!generalPractitionerUrl && (
        <Button
          variant="light"
          onClick={() => {
            history.push(generalPractitionerUrl);
          }}
        >
          Registruotis pas šeimos gydytoją
        </Button>
      )}
    </div>
  );
}
